// CSS Modules - component class name: MainMenu__

<template>
  <nav v-show="loadedElements >= 2" :class="$style.mainMenu">
    <ul :class="$style.secondaryNav">
      <li
        v-for="elm in secondaryLinks"
        :key="elm.id"
        v-tippy="{
          theme: 'wika light',
          interactive: true,
          reactive: true,
          placement: 'bottom',
          flip: false,
          animation: 'perspective',
          animateFill: false,
          arrow: true,
          distance: 7,
          zIndex: 10000,
          html: '#secondary-' + elm.id
        }"
        @init="initSecondaryNavPopper"
      >
        <a :class="{ MainMenu__active: elm.isActive }" :href="elm.url">{{
          elm.title
        }}</a>
      </li>
    </ul>
    <ul v-if="!isShop" :class="$style.primaryNav">
      <li
        v-for="elm in primaryLinks"
        :key="elm.id"
        v-tippy="{
          theme: 'wika light big',
          interactive: true,
          reactive: true,
          placement: 'bottom',
          flip: false,
          animation: 'fade',
          duration: [200, 600],
          animateFill: false,
          arrow: true,
          html: '#primary-' + elm.id
        }"
        @init="initPrimaryNavPopper"
      >
        <a :class="{ MainMenu__active: elm.isActive }" :href="elm.url">{{
          elm.title
        }}</a>
      </li>
    </ul>
    <ul v-if="isShop" :class="$style.primaryNav">
      <li
        v-for="elm in primaryLinks"
        :key="elm.id"
        v-tippy="{
          theme: 'wika light',
          interactive: true,
          reactive: true,
          placement: 'bottom',
          flip: false,
          animation: 'perspective',
          animateFill: false,
          arrow: true,
          distance: 7,
          zIndex: 10000,
          html: '#primary-' + elm.id
        }"
        @init="initShopPrimaryNavPopper"
      >
        <a :class="{ MainMenu__active: elm.isActive }" :href="elm.url">{{
          elm.title
        }}</a>
      </li>
    </ul>
    <template v-for="elm in secondaryLinks">
      <div
        v-if="Object.keys(elm).includes('subNav') && elm.subNav.length > 0"
        :key="elm.title + elm.id"
        :id="'secondary-' + elm.id"
        :class="$style.popupContent"
      >
        <ul>
          <li v-for="link in elm.subNav" :key="link.title + link.id">
            <a :href="link.url" v-html="link.title"></a>
          </li>
        </ul>
      </div>
    </template>
    <template v-if="!isShop">
      <template v-for="elm in primaryLinks">
        <div
          v-if="elm.subNav && elm.subNav.length"
          :key="elm.title + elm.id"
          :id="'primary-' + elm.id"
          :class="$style.popupContent"
        >
          <Tabs
            :tabCount="elm.subNav.length"
            padding="1rem"
            :dividerBeforeTab="elm.dividerBeforeTab"
            :tabTitles="elm.subNav"
            isVertical
            navigateOnClick
          >
            <template
              v-for="subElm in elm.subNav"
              v-slot:[tabTitleSlot(subElm)]
            >
              {{ subElm.title }}
            </template>
            <template
              v-for="subElm in elm.subNav"
              v-slot:[tabContentSlot(subElm)]
            >
              <MenuTeaserGrid
                :gridData="subElm.subNav"
                :key="subElm.title + subElm.id"
              />
            </template>
          </Tabs>
        </div>
      </template>
    </template>
    <template v-if="isShop">
      <template v-for="elm in primaryLinks">
        <div
          v-if="elm.subNav && elm.subNav.length"
          :key="elm.title + elm.id"
          :id="'primary-' + elm.id"
          :class="$style.popupContent"
        >
          <ul>
            <li v-for="link in elm.subNav" :key="link.title + link.id">
              <a :href="link.url" v-html="link.title"></a>
            </li>
          </ul>
        </div>
      </template>
    </template>
  </nav>
</template>

<script>
import Tabs from "../Tabs/Tabs.vue";
import MenuTeaserGrid from "../MenuTeaserGrid/MenuTeaserGrid.vue";

export default {
  name: "MainMenu",
  components: {
    MenuTeaserGrid,
    Tabs
  },
  props: {
    isShop: {
      type: Boolean,
      default: false
    },
    primaryLinks: {
      type: Array,
      default: () => []
    },
    secondaryLinks: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loadedElements: 0
    };
  },
  methods: {
    initPrimaryNavPopper(tippy) {
      tippy.popper.id = "primaryNavPopper";
      this.loadedElements++;
    },
    initShopPrimaryNavPopper(tippy) {
      tippy.popper.id = "shopPrimaryNavPopper";
      this.loadedElements++;
    },
    initSecondaryNavPopper(tippy) {
      tippy.popper.id = "secondaryNavPopper";
      this.loadedElements++;
    },
    tabTitleSlot(subElm) {
      return subElm.id + "-title";
    },
    tabContentSlot(subElm) {
      return subElm.id + "-content";
    }
  }
};
</script>

<style module lang="scss">
@import "./MainMenu.scss";
</style>
